import CallHistoryManagementFilters from 'components/templates/callHistoryManagement/filters';
import CallHistoryManagementHeader from 'components/templates/callHistoryManagement/header';
import CallHistoryManagementTable from 'components/templates/callHistoryManagement/table';
import { useCallHistoryManagement } from 'infrastructure/hooks/callHistoryManagement/useData';

const CallHistoryManagementPage = () => {
  const { data, isLoading, isSplitting, updateItems } =
    useCallHistoryManagement();
  return (
    <div>
      <CallHistoryManagementHeader />
      <CallHistoryManagementFilters />
      <CallHistoryManagementTable
        count={data?.count}
        data={data?.data}
        isLoading={isLoading || isSplitting}
        updateItems={updateItems}
      />
    </div>
  );
};

export default CallHistoryManagementPage;
